import { useTranslation } from "react-i18next";

import titleCase from "pstat-anywhere/utils/titleCase";
import {
  ErrorMessage,
  ErrorMessageSpan,
  ErrorPage
} from "pstat-design-system/ErrorPages";

const StartSessionErrorPage = props => {
  const errorType = window.ERROR_TYPE;
  if (errorType === "catalix_login_error") {
    return <CatalixLoginError />;
  } else if (errorType === "proxy_login_error") {
    return <ProxiedUserLoginError />;
  } else if (errorType === "ip_whitelist_error") {
    return <IpWhitelistError />;
  } else if (errorType === "account_deactivated") {
    return <AccountDeactivatedError />;
  }
  return <CatalixLoginError />;
};

const CatalixLoginError = () => {
  const { t } = useTranslation();
  return (
    <ErrorPage>
      <ErrorMessage
        id="error-title"
        title={t("errorPages.catalix.startSession.error.title")}
      >
        <ErrorMessageSpan id="error-message" mb={5}>
          {t("errorPages.catalix.startSession.error.message")}
        </ErrorMessageSpan>
        <ErrorMessageSpan id="error-suggestions" mb={5}>
          {t("errorPages.catalix.startSession.error.suggestions")}
        </ErrorMessageSpan>
      </ErrorMessage>
    </ErrorPage>
  );
};

const ProxiedUserLoginError = () => {
  const { t } = useTranslation();
  const errorContext = window.ERROR_CONTEXT || {};
  return (
    <ErrorPage>
      <ErrorMessage
        id="error-title"
        title={t("errorPages.catalix.startSession.proxyLoginError.title")}
      >
        <ErrorMessageSpan id="error-message" mb={5}>
          {t("errorPages.catalix.startSession.proxyLoginError.message", {
            proxyUserDisplay: errorContext.proxyUserDisplay
          })}
        </ErrorMessageSpan>
        <ErrorMessageSpan id="error-suggestions" mb={5}>
          {t("errorPages.catalix.startSession.proxyLoginError.suggestions", {
            documentLabelPlural: errorContext.documentLabelPlural.toLowerCase()
          })}{" "}
          <a href={errorContext.guestLoginUrl}>
            {t(
              "errorPages.catalix.startSession.proxyLoginError.continueAsGuest",
              { guestLabel: titleCase(errorContext.guestLabel) }
            )}
          </a>
        </ErrorMessageSpan>
      </ErrorMessage>
    </ErrorPage>
  );
};

const IpWhitelistError = () => {
  const { t } = useTranslation();
  return (
    <ErrorPage>
      <ErrorMessage
        id="error-title"
        title={t("errorPages.catalix.startSession.ipWhitelistError.title")}
      >
        <ErrorMessageSpan id="error-message" mb={5}>
          {t("errorPages.catalix.startSession.ipWhitelistError.message")}
        </ErrorMessageSpan>
      </ErrorMessage>
    </ErrorPage>
  );
};

const AccountDeactivatedError = () => {
  const { t } = useTranslation();
  const errorContext = window.ERROR_CONTEXT || {};
  return (
    <ErrorPage>
      <ErrorMessage
        id="error-title"
        title={t(
          "errorPages.catalix.startSession.accountDeactivatedError.title"
        )}
      >
        <ErrorMessageSpan id="error-message" mb={5}>
          {t("errorPages.catalix.startSession.accountDeactivatedError.message")}
        </ErrorMessageSpan>
        <ErrorMessageSpan id="error-suggestions" mb={5}>
          {t(
            "errorPages.catalix.startSession.accountDeactivatedError.suggestions",
            { username: errorContext.username }
          )}
        </ErrorMessageSpan>
      </ErrorMessage>
    </ErrorPage>
  );
};

export default StartSessionErrorPage;
